import client from './client';

export const getExtraction = (month) => client.get('/extraction', { params: { month } }).then((r) => r.data);
export const scanExtraction = (month) => client.post('/extraction/scan', { month }).then((r) => r.data);
export const saveExtractionKhoan = (month, khoanKg) => client.put('/extraction/khoan', { month, khoanKg }).then((r) => r.data);
